import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Application } from '../../../shared/containers/App';
import { TReduxStore } from '../../../shared/types/store';
import { IApplicationContext } from '../../../shared/types/application';

interface IDependencies {
  context: IApplicationContext;
  store: TReduxStore;
}

export function renderApplication({ context, store }: IDependencies) {
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');

  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <Application context={context} reduxStore={store} />);
}
